// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page_survey-page__XGig4{
  display: flex;
  flex-direction: column;
  gap: 21px;
}`, "",{"version":3,"sources":["webpack://./src/pages/survey-page/page.module.css"],"names":[],"mappings":"AAAA;EACI,aAAa;EACb,sBAAsB;EACtB,SAAS;AACb","sourcesContent":[".survey-page{\n    display: flex;\n    flex-direction: column;\n    gap: 21px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"survey-page": `page_survey-page__XGig4`
};
export default ___CSS_LOADER_EXPORT___;
